import { SpecificMinerPage } from "../../features/miners/specificMiner";

export const SpecificMiner = () => {
    // TODO: ADD SEO TAGS
    return <SpecificMinerPage />;
};
